export const AUTH_START_SAGA = "AUTH_START_SAGA";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT_SAGA = "AUTH_LOGOUT_SAGA";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const INIT_ORDER = " INIT_ORDER";
export const PLACE_ORDER = " PLACE_ORDER";
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAIL = "PLACE_ORDER_FAIL";
export const ORDERS_FAILED = "ORDERS_FAILED";
export const FETCH_ORDERS_SAGA = "FETCH_ORDERS_SAGA";
export const SET_FETCHED_ORDERS = "SET_FETCHED_ORDERS";

export const PURCHASE_FOOD_SAGA = "PURCHASE_FOOD_SAGA";
export const INIT_PURCHASE = "INIT_PURCHASE";
export const INIT_FETCH = "INIT_FETCH";
export const INIT_DELETE = "INIT_DELETE";
export const UPDATE_ORDER_SAGA = "UPDATE_ORDER_SAGA";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const DELETE_ORDER_SAGA = "DELETE_ORDER_SAGA";
export const DELETE_ORDER = "DELETE_ORDER";

// export const ADD_INGREDIENT = " ADD_INGREDIENT";
// export const EDIT_INGREDIENT = " EDIT_INGREDIENT";
// export const DELETE_INGREDIENT = " DELETE_INGREDIENT";
// export const ADD_TO_SHOPLIST = " ADD_TO_SHOPLIST";

// export const GET_RECIPES = " GET_RECIPES";
// export const SELECTED_RECIPE = " SELECTED_RECIPE";
// export const ADD_RECIPE = " ADD_RECIPE";
// export const EDIT_RECIPE = " EDIT_RECIPE";
// export const DELETE_RECIPE = "DELETE_RECIPE";
